"use client"

import RegisterSW from "./register-sw"

interface PWAProps {
  skipInDevMode?: boolean // pwa caching doesnt work well with HMR, so better skip it
  showDebugButton?: boolean
}

export function PWA({ skipInDevMode, showDebugButton }: PWAProps) {
  if (skipInDevMode && process.env.NODE_ENV === "development") return null

  return (
    <>
      <RegisterSW />
    </>
  )
}
